import { motion } from 'framer-motion';
import React from 'react';
import { Timeline, TimelineItem } from './timeline';
import type { TimelineElement } from './timeline-types';

interface TimelineLayoutProps {
  items: TimelineElement[];
  customIcon?: React.ReactNode;
  animate?: boolean;
  className?: string;
}

export const TimelineLayout = ({
  items,
  customIcon,
  animate = true,
  className,
}: TimelineLayoutProps) => {
  return (
    <Timeline className={className}>
      {[...items].map((item, index) => (
        <motion.div
          key={index}
          initial={animate ? { opacity: 0, y: 20 } : false}
          animate={animate ? { opacity: 1, y: 0 } : false}
          transition={{
            duration: 0.5,
            delay: index * 0.1,
            ease: 'easeOut',
          }}
        >
          <TimelineItem
            date={new Date(item.date)}
            title={item.title}
            initiator={item.initiator}
            description={item.description}
            selected={item.selected}
            iconColor={item.color}
            subSteps={item.subSteps}
            onClick={item.onClick}
            icon={
              typeof item.icon === 'function'
                ? item.icon()
                : item.icon || customIcon
            }
            showHighlight={item.showHighlight}
            showConnector={index !== items.length - 1}
          />
        </motion.div>
      ))}
    </Timeline>
  );
};
